<div
  class="cg-dialog"
  aria-labelledby="header"
  data-test="delete-confirmation-modal"
>
  <h3
    id="header"
    class="cg-dialog__header cg-dialog__header--modal dialog-header"
  >
    Delete Message(s)
  </h3>
  <p>This will delete the message(s) permanently. Please confirm.</p>

  <div class="cg-button-group cg-margin-top-lg">
    <button
      cignaButton="primary"
      (click)="dialogRef.close({ canDelete: true })"
      data-test="delete-file"
    >
      Delete
    </button>
    <button
      cignaButton="link no-underline"
      (click)="dialogRef.close()"
      data-test="cancel"
    >
      Cancel
    </button>
  </div>
</div>
